export class ListAzureSubnets200ResponseSubnetsInner {
    'name';
    'id';
    'addressPrefix';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "addressPrefix",
            "baseName": "addressPrefix",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListAzureSubnets200ResponseSubnetsInner.attributeTypeMap;
    }
    constructor() {
    }
}
